export enum UserStatus {
  'ACTIVE' = 'ACTIVE',
  'INACTIVE' = 'INACTIVE',
  'BLOCKED' = 'BLOCKED',
  'DELETED' = 'DELETED',
}
